export default [
  {
    path: '/onboarding',
    name: 'OnBoarding',
    component: () => import('@/components/master/onboarding/ProviderCandidate'),
    meta: {
      title: 'Provider Candidate',
      requiresAuth: true,
      services: ['OnBoarding']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/onBoardingModule.js